module.exports = __webpack_public_path__ + "assets/img/evalItem01.6309e831.png";